// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__11952","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2bPHf"};